/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PriceOfferDiscountResponse
 */
export interface PriceOfferDiscountResponse {
    /**
     * 
     * @type {string}
     * @memberof PriceOfferDiscountResponse
     */
    'code'?: string;
    /**
     * 
     * @type {number}
     * @memberof PriceOfferDiscountResponse
     */
    'amount'?: number;
    /**
     * 
     * @type {string}
     * @memberof PriceOfferDiscountResponse
     */
    'status'?: PriceOfferDiscountResponseStatusEnum;
}

export const PriceOfferDiscountResponseStatusEnum = {
    Applicable: 'APPLICABLE',
    NotApplicable: 'NOT_APPLICABLE',
    NotFound: 'NOT_FOUND'
} as const;

export type PriceOfferDiscountResponseStatusEnum = typeof PriceOfferDiscountResponseStatusEnum[keyof typeof PriceOfferDiscountResponseStatusEnum];


